import { SVGAttributes } from 'react'

export const BigSIcon = (props: SVGAttributes<SVGSVGElement>) => (
  <svg
    width='202'
    height='270'
    viewBox='0 0 202 303'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g opacity='0.2' clipPath='url(#clip0_89_10623)'>
      <path
        d='M182.164 175.954L175.738 171.667L175.787 171.617L131.692 142.243L131.593 142.292L108.162 126.718C88.9813 113.953 86.7567 93.9922 91.1564 79.453C95.556 65.0122 108.458 49.5858 131.544 49.5858C154.63 49.5858 167.581 65.0122 171.981 79.5023C173.217 83.4944 173.909 87.8808 173.909 92.4151C173.909 101.336 171.141 110.848 164.022 118.931L204.706 146.383C222.057 123.81 227.693 94.4358 218.844 65.3573C206.931 26.1258 172.673 0.792969 131.593 0.792969C90.5137 0.792969 56.256 26.1258 44.3424 65.3573C33.7635 100.153 43.9469 135.54 70.2458 159L137.476 204.885L154.976 216.517C174.205 229.282 176.381 249.193 171.981 263.732C167.581 278.173 154.679 293.649 131.544 293.649C108.458 293.649 95.5065 278.222 91.1564 263.732C87.5477 251.953 88.3881 236.379 99.313 224.107L58.8265 196.359C46.7152 211.933 40.1899 230.76 40.1899 250.573C40.1899 259.543 41.5247 268.759 44.293 277.877C56.2065 317.109 90.4643 342.442 131.544 342.442C172.673 342.442 206.881 317.109 218.844 277.877C230.758 238.744 216.373 198.675 182.164 175.954Z'
        fill='url(#paint0_linear_89_10623)'
      />
      <mask
        id='mask0_89_10623'
        mask-type='luminance'
        maskUnits='userSpaceOnUse'
        x='-1'
        y='-59'
        width='286'
        height='283'
      >
        <path
          d='M161.118 -58.3345L-0.0117188 79.5135L123.797 223.366L284.927 85.5178L161.118 -58.3345Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_89_10623)'>
        <path
          d='M182.164 176.546L175.738 172.258L175.787 172.209L131.692 142.834L131.593 142.884L108.161 127.309C88.981 114.544 86.7565 94.5836 91.1561 80.0443C95.5557 65.6036 108.458 50.1771 131.544 50.1771C154.629 50.1771 167.581 65.6036 171.981 80.0936C173.216 84.0857 173.909 88.4721 173.909 93.0064C173.909 101.927 171.14 111.439 164.022 119.522L204.706 146.974C222.057 124.401 227.693 95.0271 218.844 65.9486C206.93 26.7171 172.673 1.38428 131.593 1.38428C90.5135 1.38428 56.2557 26.7171 44.3422 65.9486C33.7633 100.744 43.9467 136.131 70.2455 159.591L137.476 205.476L154.975 217.108C174.205 229.873 176.38 249.784 171.981 264.324C167.581 278.764 154.679 294.24 131.544 294.24C108.458 294.24 95.5063 278.814 91.1561 264.324C87.5474 252.544 88.3878 236.97 99.3127 224.698L58.8263 196.95C46.715 212.524 40.1897 231.351 40.1897 251.164C40.1897 260.134 41.5244 269.351 44.2927 278.469C56.2063 317.7 90.464 343.033 131.544 343.033C172.673 343.033 206.881 317.7 218.844 278.469C230.758 239.336 216.372 199.266 182.164 176.546Z'
          fill='url(#paint1_linear_89_10623)'
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_89_10623'
        x1='40.2058'
        y1='171.681'
        x2='222.996'
        y2='171.681'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#65C8D0' />
        <stop offset='1' stopColor='#3A8CA5' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_89_10623'
        x1='40.2055'
        y1='172.273'
        x2='222.995'
        y2='172.273'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#F7931E' />
        <stop offset='1' stopColor='#DB9F5D' stopOpacity='0.9' />
      </linearGradient>
      <clipPath id='clip0_89_10623'>
        <rect
          width='262'
          height='345'
          fill='white'
          transform='translate(0 0.792969)'
        />
      </clipPath>
    </defs>
  </svg>
)
